import { Authorization } from "../../common/utils/authorization";

export class Qm10SecApis {
  constructor(private url: string, private authKeeper: Authorization) {}
  addIfFound(newObj: any, key: string, value: any, errorObj: { [key: string]: any }, required: boolean) {
    if (typeof value !== "undefined") {
      if (value !== null) {
        newObj[key] = value;
      } else {
        if (required) {
          errorObj[key] = false;
        }
      }
    } else {
      if (required) {
        errorObj[key] = false;
      }
    }
  }

  async verifyPromoCodeAndGetDetails(args: {
    customerId: string;
    promoCode: string;
    product?: string;
    subProduct?: string;
  }): Promise<{
    result?: {
      offer?: {
        token?: string;
        customerName?: string;
        customerId?: string;
        promoCode?: string;
        product?: string;
        subProduct?: string;
        campaignId?: string;
        loanAvailed?: boolean;
        mobile?: string;
        createdOn?: string;
        email?: string;
        aadharNo?: string;
        pdApplicantFirstName?: string;
        pdApplicantLastName?: string;
        pdApplicantMiddleName?: string;
        pdPresentAddress1?: string;
        pdPresentAddress2?: string;
        pdPresentAddress3?: string;
        pdPresentCity?: string;
        pdPresentPin?: string;
        pdPresentState?: string;
        dob?: string;
        pdPanNo?: string;
        pdPresentLandMark?: string;
        edCompanyName?: string;
        edPresentAddress1?: string;
        edPresentAddress2?: string;
        edPresentAddress3?: string;
        edPresentCity?: string;
        edPresentLandMark?: string;
        edPresentPin?: string;
        edPresentState?: string;
        edPresentStd?: string;
        edPresentPhone?: string;
        salutation?: string;
        sex?: string;
        maritalStatus?: string;
        accountNo?: string;
        bankName?: string;
        bankAccount?: string;
        branch?: string;
        emi?: string;
        interestRate?: string;
        loanAmt?: string;
        processingFees?: string;
        tenure?: string;
        engineNumber?: string;
        chassisNumber?: string;
        registrationNumberVehicleNumber?: string;
        existingLoanAccountNumber?: string;
        modelDescription?: string;
        manufacturer?: string;
        lgCode?: string;
        smCode?: string;
        branchCode?: string;
        seCode?: string;
        customerRating?: string;
        customerCategory?: string;
        assetCost?: string;
        natureOfBusiness?: string;
        typeOfOffice?: string;
        typeOfIndustry?: string;
        typeOfCompany?: string;
        designation?: string;
        yearsInCurrentProfession?: string;
        totalWorkExperience?: string;
        make?: string;
        motorInsurancePremiumAmountY?: string;
        motorInsurancePremiumAmountN?: string;
        dealerName?: string;
        dealerState?: string;
        dealerCity?: string;
        dealerAddress1?: string;
        dealerAddress2?: string;
        dealerAddress3?: string;
        dealerEmail?: string;
        dealerMobile?: string;
        dealerPinCode?: string;
      };
      lead?: { leadId?: string };
    };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, true);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, true);
      this.addIfFound(bodyParams, "product", args.product, errorObj, false);
      this.addIfFound(bodyParams, "subProduct", args.subProduct, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/verify-promo-code`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            resolve(res);
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updateCarInfo(args: {
    customerId: string;
    product: string;
    subProduct?: string;
    leadId: string;
    shardKey: string;
    registrationNumberVehicleNumber: string;
    engineNumber: string;
    chassisNumber: string;
    existingLoanAccount: string;
    motorInsuranceAvailed: boolean;
    motorInsurancePremium: string;
    motorInsuranceClaimed: boolean;
    motorInsurancePremiumEditAmount: string;
  }): Promise<{
    result?: { updated?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, true);
      this.addIfFound(bodyParams, "product", args.product, errorObj, true);
      this.addIfFound(bodyParams, "subProduct", args.subProduct, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, true);
      this.addIfFound(bodyParams, "shardKey", args.shardKey, errorObj, true);
      this.addIfFound(bodyParams, "registrationNumberVehicleNumber", args.registrationNumberVehicleNumber, errorObj, true);
      this.addIfFound(bodyParams, "engineNumber", args.engineNumber, errorObj, true);
      this.addIfFound(bodyParams, "chassisNumber", args.chassisNumber, errorObj, true);
      this.addIfFound(bodyParams, "existingLoanAccount", args.existingLoanAccount, errorObj, true);
      this.addIfFound(bodyParams, "motorInsuranceAvailed", args.motorInsuranceAvailed, errorObj, true);
      this.addIfFound(bodyParams, "motorInsurancePremium", args.motorInsurancePremium, errorObj, true);
      this.addIfFound(bodyParams, "motorInsuranceClaimed", args.motorInsuranceClaimed, errorObj, true);
      this.addIfFound(bodyParams, "motorInsurancePremiumEditAmount", args.motorInsurancePremiumEditAmount, errorObj, true);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/update-car-details`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getServiceTax(args: {
    leadId?: string;
  }): Promise<{
    result?: { serviceTax?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/get-service-tax`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getStampDuty(args: {
    tenure?: number;
    loanAmount?: number;
    product?: string;
    subProduct?: string;
    type?: string;
    state?: string;
  }): Promise<{
    result?: { stampDuty?: string };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "tenure", args.tenure, errorObj, false);
      this.addIfFound(bodyParams, "loanAmount", args.loanAmount, errorObj, false);
      this.addIfFound(bodyParams, "product", args.product, errorObj, false);
      this.addIfFound(bodyParams, "subProduct", args.subProduct, errorObj, false);
      this.addIfFound(bodyParams, "type", args.type, errorObj, false);
      this.addIfFound(bodyParams, "state", args.state, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/get-stamp-duty`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getInterestRateMaster(args: {
    tenure?: number;
    loanAmount?: number;
  }): Promise<{
    result?: { interestRate?: number };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "tenure", args.tenure, errorObj, false);
      this.addIfFound(bodyParams, "loanAmount", args.loanAmount, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/get-Interest-rate`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getBankData(args: {
    lgCode?: string;
  }): Promise<{
    result?: { codes?: Array<{ branchCode?: string; lgCode?: string; smCode?: string; seCode?: string; dsa?: string; tse?: string; tl?: string }> };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "lgCode", args.lgCode, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/get-bank-data`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updateLoanInfo(args: {
    leadId: string;
    liLoanAmount: string;
    liTenure: string;
    liInterestRate: string;
    liEMI: string;
    liPurposeLoan?: string;
    processingFees?: string;
    amountPayable?: string;
    emiEndDate?: string;
    emiStartDate?: string;
    maxLoanFunded?: string;
    marginMoneyPaid?: string;
    uniqueReferenceNo?: string;
    insuranceAvailed?: boolean;
    insuranceName?: string;
    insuranceNomineeName?: string;
    insuranceNomineeGender?: string;
    insuranceNomineeRelation?: string;
    insuranceNomineeDob?: string;
    insuranceSsiPremium?: string;
    stampDuty?: string;
    loanAmtSelectedByUser?: string;
    preApprovedLoanAmt?: string;
  }): Promise<{
    result?: { updated?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, true);
      this.addIfFound(bodyParams, "liLoanAmount", args.liLoanAmount, errorObj, true);
      this.addIfFound(bodyParams, "liTenure", args.liTenure, errorObj, true);
      this.addIfFound(bodyParams, "liInterestRate", args.liInterestRate, errorObj, true);
      this.addIfFound(bodyParams, "liEMI", args.liEMI, errorObj, true);
      this.addIfFound(bodyParams, "liPurposeLoan", args.liPurposeLoan, errorObj, false);
      this.addIfFound(bodyParams, "processingFees", args.processingFees, errorObj, false);
      this.addIfFound(bodyParams, "amountPayable", args.amountPayable, errorObj, false);
      this.addIfFound(bodyParams, "emiEndDate", args.emiEndDate, errorObj, false);
      this.addIfFound(bodyParams, "emiStartDate", args.emiStartDate, errorObj, false);
      this.addIfFound(bodyParams, "maxLoanFunded", args.maxLoanFunded, errorObj, false);
      this.addIfFound(bodyParams, "marginMoneyPaid", args.marginMoneyPaid, errorObj, false);
      this.addIfFound(bodyParams, "uniqueReferenceNo", args.uniqueReferenceNo, errorObj, false);
      this.addIfFound(bodyParams, "insuranceAvailed", args.insuranceAvailed, errorObj, false);
      this.addIfFound(bodyParams, "insuranceName", args.insuranceName, errorObj, false);
      this.addIfFound(bodyParams, "insuranceNomineeName", args.insuranceNomineeName, errorObj, false);
      this.addIfFound(bodyParams, "insuranceNomineeGender", args.insuranceNomineeGender, errorObj, false);
      this.addIfFound(bodyParams, "insuranceNomineeRelation", args.insuranceNomineeRelation, errorObj, false);
      this.addIfFound(bodyParams, "insuranceNomineeDob", args.insuranceNomineeDob, errorObj, false);
      this.addIfFound(bodyParams, "insuranceSsiPremium", args.insuranceSsiPremium, errorObj, false);
      this.addIfFound(bodyParams, "stampDuty", args.stampDuty, errorObj, false);
      this.addIfFound(bodyParams, "loanAmtSelectedByUser", args.loanAmtSelectedByUser, errorObj, false);
      this.addIfFound(bodyParams, "preApprovedLoanAmt", args.preApprovedLoanAmt, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/update-loan-details`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getStates(args: {
    leadId?: string;
  }): Promise<{
    result?: Array<{ state?: string }>;
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/get-states`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getSarvSurakshaPremium(args: {
    tenure?: number;
  }): Promise<{
    result?: { premium?: number };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "tenure", args.tenure, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/get-sarv-surksha`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getCities(args: {
    state?: string;
  }): Promise<{
    result?: { cities?: Array<{ city?: string }> };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "state", args.state, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/get-cities`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async successDetails(args: {
    customerId?: string;
    promoCode?: string;
    product?: string;
    subProduct?: string;
    leadId?: string;
  }): Promise<{ result?: {}; error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } } }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, false);
      this.addIfFound(bodyParams, "product", args.product, errorObj, false);
      this.addIfFound(bodyParams, "subProduct", args.subProduct, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/success-details`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async acceptTermCondition(args: {
    customerId?: string;
    promoCode?: string;
    product?: string;
    subProduct?: string;
    uniqueReferenceNo?: string;
    leadId?: string;
    termCondition?: boolean;
    natureOfRelation?: string;
    encryptedInput?: string;
    encryptedValue?: string;
    iv?: string;
  }): Promise<{ result?: {}; error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } } }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, false);
      this.addIfFound(bodyParams, "product", args.product, errorObj, false);
      this.addIfFound(bodyParams, "subProduct", args.subProduct, errorObj, false);
      this.addIfFound(bodyParams, "uniqueReferenceNo", args.uniqueReferenceNo, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);
      this.addIfFound(bodyParams, "termCondition", args.termCondition, errorObj, false);
      this.addIfFound(bodyParams, "natureOfRelation", args.natureOfRelation, errorObj, false);
      this.addIfFound(bodyParams, "encryptedInput", args.encryptedInput, errorObj, false);
      this.addIfFound(bodyParams, "encryptedValue", args.encryptedValue, errorObj, false);
      this.addIfFound(bodyParams, "iv", args.iv, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/terms-and-conditions`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async resendOtp(args: {
    leadId?: string;
  }): Promise<{
    result?: { updated?: boolean; otpAttempt?: number };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/resend-otp`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async finalSubmit(args: {
    customerId?: string;
    promoCode?: string;
    product?: string;
    subProduct?: string;
    leadId?: string;
    otp?: string;
  }): Promise<{
    result?: { loanAvailed?: boolean; inValidOTP?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, false);
      this.addIfFound(bodyParams, "product", args.product, errorObj, false);
      this.addIfFound(bodyParams, "subProduct", args.subProduct, errorObj, false);
      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);
      this.addIfFound(bodyParams, "otp", args.otp, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/final-submit`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updatePersonalInfoData(args: {
    leadId?: string;
    pdPresentMobile?: string;
    pdPresentEmail?: string;
    pdFirstName?: string;
    pdLastName?: string;
    pdMiddleName?: string;
    pdPresentAddress?: string;
    pdPresentAddress2?: string;
    pdPresentAddress3?: string;
    pdCity?: string;
    pdLandmark?: string;
    pdPinCode?: string;
    pdState?: string;
    pdPanNo?: string;
    pdPresentLandlineStd?: string;
    pdPresentPhone?: string;
    pdDob?: string;
    pdSex?: string;
    pdMaritalStatus?: string;
    pdACC?: string;
    pdSalutation?: string;
    pdIsAddressSame?: string;
    prefAddFlag?: string;
    pdPermAddress?: string;
    pdPermAddress2?: string;
    pdPermAddress3?: string;
    pdPermCity?: string;
    pdPermLandmark?: string;
    pdPermPinCode?: string;
    pdPermState?: string;
    pdPermLandlineSTD?: string;
    pdPermPhone?: string;
    pdPermMobile?: string;
    pdPermEmail?: string;
    edIndustry?: string;
    edConstitution?: string;
    edProfession?: string;
    edCompanyName?: string;
    edOfficeAddress?: string;
    edOfficeAddress2?: string;
    edOfficeAddress3?: string;
    edOfficeState?: string;
    edOfficeCity?: string;
    edOfficePinCode?: string;
    edOfficeSTD?: string;
    edOfficePhone?: string;
    edOfficeExt?: string;
    edLandmark?: string;
    edPreferredAddress?: string;
    edOfficeEmail?: string;
    pdPanNoIsValid?: string;
    ed1OfficeAddress?: string;
    ed1OfficeAddress2?: string;
    ed1OfficeAddress3?: string;
    ed1OfficeState?: string;
    ed1OfficeCity?: string;
    ed1OfficePinCode?: string;
    ed1OfficeSTD?: string;
    ed1OfficePhone?: string;
    ed1OfficeExt?: string;
    ed1Landmark?: string;
    ed1OfficeEmail?: string;
    identityProof?: string;
    residenceProof?: string;
    residenceType?: string;
    natureOfRelation?: string;
    fdMonthlySalary?: string;
    edIsAddressSame?: string;
    branchCode?: string;
    lgCode?: string;
    smCode?: string;
    seCode?: string;
    dsaCode?: string;
    tseCode?: string;
    tlCode?: string;
    aadharNo?: string;
  }): Promise<{
    result?: { updated?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);
      this.addIfFound(bodyParams, "pdPresentMobile", args.pdPresentMobile, errorObj, false);
      this.addIfFound(bodyParams, "pdPresentEmail", args.pdPresentEmail, errorObj, false);
      this.addIfFound(bodyParams, "pdFirstName", args.pdFirstName, errorObj, false);
      this.addIfFound(bodyParams, "pdLastName", args.pdLastName, errorObj, false);
      this.addIfFound(bodyParams, "pdMiddleName", args.pdMiddleName, errorObj, false);
      this.addIfFound(bodyParams, "pdPresentAddress", args.pdPresentAddress, errorObj, false);
      this.addIfFound(bodyParams, "pdPresentAddress2", args.pdPresentAddress2, errorObj, false);
      this.addIfFound(bodyParams, "pdPresentAddress3", args.pdPresentAddress3, errorObj, false);
      this.addIfFound(bodyParams, "pdCity", args.pdCity, errorObj, false);
      this.addIfFound(bodyParams, "pdLandmark", args.pdLandmark, errorObj, false);
      this.addIfFound(bodyParams, "pdPinCode", args.pdPinCode, errorObj, false);
      this.addIfFound(bodyParams, "pdState", args.pdState, errorObj, false);
      this.addIfFound(bodyParams, "pdPanNo", args.pdPanNo, errorObj, false);
      this.addIfFound(bodyParams, "pdPresentLandlineStd", args.pdPresentLandlineStd, errorObj, false);
      this.addIfFound(bodyParams, "pdPresentPhone", args.pdPresentPhone, errorObj, false);
      this.addIfFound(bodyParams, "pdDob", args.pdDob, errorObj, false);
      this.addIfFound(bodyParams, "pdSex", args.pdSex, errorObj, false);
      this.addIfFound(bodyParams, "pdMaritalStatus", args.pdMaritalStatus, errorObj, false);
      this.addIfFound(bodyParams, "pdACC", args.pdACC, errorObj, false);
      this.addIfFound(bodyParams, "pdSalutation", args.pdSalutation, errorObj, false);
      this.addIfFound(bodyParams, "pdIsAddressSame", args.pdIsAddressSame, errorObj, false);
      this.addIfFound(bodyParams, "prefAddFlag", args.prefAddFlag, errorObj, false);
      this.addIfFound(bodyParams, "pdPermAddress", args.pdPermAddress, errorObj, false);
      this.addIfFound(bodyParams, "pdPermAddress2", args.pdPermAddress2, errorObj, false);
      this.addIfFound(bodyParams, "pdPermAddress3", args.pdPermAddress3, errorObj, false);
      this.addIfFound(bodyParams, "pdPermCity", args.pdPermCity, errorObj, false);
      this.addIfFound(bodyParams, "pdPermLandmark", args.pdPermLandmark, errorObj, false);
      this.addIfFound(bodyParams, "pdPermPinCode", args.pdPermPinCode, errorObj, false);
      this.addIfFound(bodyParams, "pdPermState", args.pdPermState, errorObj, false);
      this.addIfFound(bodyParams, "pdPermLandlineSTD", args.pdPermLandlineSTD, errorObj, false);
      this.addIfFound(bodyParams, "pdPermPhone", args.pdPermPhone, errorObj, false);
      this.addIfFound(bodyParams, "pdPermMobile", args.pdPermMobile, errorObj, false);
      this.addIfFound(bodyParams, "pdPermEmail", args.pdPermEmail, errorObj, false);
      this.addIfFound(bodyParams, "edIndustry", args.edIndustry, errorObj, false);
      this.addIfFound(bodyParams, "edConstitution", args.edConstitution, errorObj, false);
      this.addIfFound(bodyParams, "edProfession", args.edProfession, errorObj, false);
      this.addIfFound(bodyParams, "edCompanyName", args.edCompanyName, errorObj, false);
      this.addIfFound(bodyParams, "edOfficeAddress", args.edOfficeAddress, errorObj, false);
      this.addIfFound(bodyParams, "edOfficeAddress2", args.edOfficeAddress2, errorObj, false);
      this.addIfFound(bodyParams, "edOfficeAddress3", args.edOfficeAddress3, errorObj, false);
      this.addIfFound(bodyParams, "edOfficeState", args.edOfficeState, errorObj, false);
      this.addIfFound(bodyParams, "edOfficeCity", args.edOfficeCity, errorObj, false);
      this.addIfFound(bodyParams, "edOfficePinCode", args.edOfficePinCode, errorObj, false);
      this.addIfFound(bodyParams, "edOfficeSTD", args.edOfficeSTD, errorObj, false);
      this.addIfFound(bodyParams, "edOfficePhone", args.edOfficePhone, errorObj, false);
      this.addIfFound(bodyParams, "edOfficeExt", args.edOfficeExt, errorObj, false);
      this.addIfFound(bodyParams, "edLandmark", args.edLandmark, errorObj, false);
      this.addIfFound(bodyParams, "edPreferredAddress", args.edPreferredAddress, errorObj, false);
      this.addIfFound(bodyParams, "edOfficeEmail", args.edOfficeEmail, errorObj, false);
      this.addIfFound(bodyParams, "pdPanNoIsValid", args.pdPanNoIsValid, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficeAddress", args.ed1OfficeAddress, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficeAddress2", args.ed1OfficeAddress2, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficeAddress3", args.ed1OfficeAddress3, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficeState", args.ed1OfficeState, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficeCity", args.ed1OfficeCity, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficePinCode", args.ed1OfficePinCode, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficeSTD", args.ed1OfficeSTD, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficePhone", args.ed1OfficePhone, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficeExt", args.ed1OfficeExt, errorObj, false);
      this.addIfFound(bodyParams, "ed1Landmark", args.ed1Landmark, errorObj, false);
      this.addIfFound(bodyParams, "ed1OfficeEmail", args.ed1OfficeEmail, errorObj, false);
      this.addIfFound(bodyParams, "identityProof", args.identityProof, errorObj, false);
      this.addIfFound(bodyParams, "residenceProof", args.residenceProof, errorObj, false);
      this.addIfFound(bodyParams, "residenceType", args.residenceType, errorObj, false);
      this.addIfFound(bodyParams, "natureOfRelation", args.natureOfRelation, errorObj, false);
      this.addIfFound(bodyParams, "fdMonthlySalary", args.fdMonthlySalary, errorObj, false);
      this.addIfFound(bodyParams, "edIsAddressSame", args.edIsAddressSame, errorObj, false);
      this.addIfFound(bodyParams, "branchCode", args.branchCode, errorObj, false);
      this.addIfFound(bodyParams, "lgCode", args.lgCode, errorObj, false);
      this.addIfFound(bodyParams, "smCode", args.smCode, errorObj, false);
      this.addIfFound(bodyParams, "seCode", args.seCode, errorObj, false);
      this.addIfFound(bodyParams, "dsaCode", args.dsaCode, errorObj, false);
      this.addIfFound(bodyParams, "tseCode", args.tseCode, errorObj, false);
      this.addIfFound(bodyParams, "tlCode", args.tlCode, errorObj, false);
      this.addIfFound(bodyParams, "aadharNo", args.aadharNo, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/update-personal`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async updateHigherLoan(args: {
    customerId?: string;
    promoCode?: string;
    dropOffPromoCode?: string;
    firstName?: string;
    lastName?: string;
    mobileNo?: string;
    email?: string;
    city?: string;
    preApprovedLoanAmt?: string;
    loanRequired?: string;
    product?: string;
    subProduct?: string;
    encryptedInput?: string;
    encryptedValue?: string;
    iv?: string;
  }): Promise<{
    result?: { updated?: boolean };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "customerId", args.customerId, errorObj, false);
      this.addIfFound(bodyParams, "promoCode", args.promoCode, errorObj, false);
      this.addIfFound(bodyParams, "dropOffPromoCode", args.dropOffPromoCode, errorObj, false);
      this.addIfFound(bodyParams, "firstName", args.firstName, errorObj, false);
      this.addIfFound(bodyParams, "lastName", args.lastName, errorObj, false);
      this.addIfFound(bodyParams, "mobileNo", args.mobileNo, errorObj, false);
      this.addIfFound(bodyParams, "email", args.email, errorObj, false);
      this.addIfFound(bodyParams, "city", args.city, errorObj, false);
      this.addIfFound(bodyParams, "preApprovedLoanAmt", args.preApprovedLoanAmt, errorObj, false);
      this.addIfFound(bodyParams, "loanRequired", args.loanRequired, errorObj, false);
      this.addIfFound(bodyParams, "product", args.product, errorObj, false);
      this.addIfFound(bodyParams, "subProduct", args.subProduct, errorObj, false);
      this.addIfFound(bodyParams, "encryptedInput", args.encryptedInput, errorObj, false);
      this.addIfFound(bodyParams, "encryptedValue", args.encryptedValue, errorObj, false);
      this.addIfFound(bodyParams, "iv", args.iv, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/update-higher-loan`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }

  async getReviewDetails(args: {
    leadId?: string;
  }): Promise<{
    result?: {
      liLoanAmount?: string;
      liTenure?: string;
      liInterestRate?: string;
      liEMI?: string;
      liPurposeLoan?: string;
      processingFees?: string;
      amountPayable?: string;
      emiEndDate?: string;
      emiStartDate?: string;
      stampDuty?: string;
      motorInsuranceAvailed?: string;
      motorInsurancePremiumEditAmount?: string;
      maxLoanFunded?: string;
      marginMoneyPaid?: string;
      loanAmtSelectedByUser?: string;
      uniqueReferenceNo?: string;
    };
    error?: { error: boolean; message: string; errorCode?: string; paramsError?: { [key: string]: any } };
  }> {
    // Custom Code goes here;
    return new Promise((resolve, reject) => {
      let bodyParams = {},
        errorObj = {};

      this.addIfFound(bodyParams, "leadId", args.leadId, errorObj, false);

      if (Object.keys(errorObj).length > 0) {
        resolve({
          error: {
            error: true,
            message: "Params not enough",
            paramsError: errorObj,
          },
        });
      } else {
        let apiUrl = `${this.url}/qm10sec/get-review`;

        let fetchOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", authorization: this.authKeeper.authorization },
          body: JSON.stringify(bodyParams),
        };
        fetch(apiUrl, fetchOptions)
          .then(async (response) => {
            let res = await response.json();
            if (response.headers.has("authorization")) {
              this.authKeeper.setAuthorization(response.headers.get("authorization"));
              resolve(res);
            } else {
              resolve({ error: { error: true, message: "authorization token invalid" } });
            }
          })
          .catch((err) => {
            resolve(err);
          });
      }
    });
  }
}
